import { gallery } from './components/gallery';
import { map } from './components/map';
import { popup } from './components/popup';
import { spoller } from './components/spoller';
import { subMenu } from './components/subMenu';
import { numbers } from './components/numbers';
import { burger } from './components/burger';
import { showMore } from './components/showmore';
import { select } from './components/select';
import { fixedMenu } from './components/fixedMenu';
import { video } from './components/video';

burger();
gallery();
popup();
numbers();
subMenu();
map();
spoller();
showMore();
select();
fixedMenu()
video()
